import gql from "graphql-tag";

export const UPDATEINVOICE = gql`
  mutation updateInvoice($Invoice_Number: String!, $Items: [inputItems]) {
    updateInvoice(Invoice_Number: $Invoice_Number, Items: $Items) {
      ResultCount
    }
  }
`;

export const UPDATEINVOICESTATUS = gql`
  mutation updateInvoiceStatus($Invoice_Number: String!, $Status: String!) {
    updateInvoiceStatus(Invoice_Number: $Invoice_Number, Status: $Status) {
      ResultCount
    }
  }
`;

export const CREATEINVOICE = gql`
  mutation createInvoice($CustNum: String!, $InsertItems: [inputItems]) {
    createInvoice(CustNum: $CustNum, InsertItems: $InsertItems) {
      ResultCount
    }
  }
`;

export const CREATESHORTAGE = gql`
  mutation createShortage($ItemNum: String) {
    createShortage(ItemNum: $ItemNum) {
      ResultCount
    }
  }
`;

export const DELETESHORTAGE = gql`
  mutation deleteShortage($ItemNum: String) {
    deleteShortage(ItemNum: $ItemNum) {
      ResultCount
    }
  }
`;

export const CREATETEMPLATE = gql`
  mutation createTemplate($custNum: String!, $itemNum: String) {
    createTemplate(CustNum: $custNum, ItemNum: $itemNum) {
      ResultCount
    }
  }
`;

export const DELETETEMPLATE = gql`
  mutation deleteTemplate($_id: Int) {
    deleteTemplate(_id: $_id) {
      ResultCount
    }
  }
`;

export const DELETE_INVOICE = gql`
  mutation deleteInvoice($Invoice_Number: String!) {
    deleteInvoice(Invoice_Number: $Invoice_Number) {
      ResultCount
    }
  }
`;
